import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
  masters: [],
  cities: [],
  masters: null,
  error: "",
  loading: false,
};

// ADD_terminationReason
export const addMaster = createAsyncThunk(
  "masters/addMaster",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `masters`,
        data: {
          ...values,
        },
      });
      toast.success("Master Reason added successfully!");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding Master Reason try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const addEmailConfiguration = createAsyncThunk(
  "masters/addEmailConfiguration",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `master/EmailConfigurationSetUp`,
        data: {
          ...values,
        },
      });
      toast.success("Master Reason added successfully!");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding Master Reason try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

// DELETE_terminationReason
export const deleteMaster = createAsyncThunk(
  "masters/deleteMaster ",
  async (id) => {
    try {
      const resp = await axios({
        method: "delete",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `masters/${id}`,
      });

      toast.success("Master Reason deleted successfully!");
      return {
        data: resp.data.id,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in deleting Master Reason try again");
      // console.log(error.message);
    }
  }
);

// masters;
export const getAllMaster = createAsyncThunk(
  "masters/getAllMaster",
  async () => {
    try {
      // const { data } = await axios.get(`master/GetCompanyMasterData`);
      const { data } = await axios.get(`company/GetCompanyMasterData`);

      // console.log("masterDataSlice", data);

      return data;
    } catch (error) {
      // console.log(error.message);
    }
  }
);

export const getAllMasterwithoutToken = createAsyncThunk(
  "masters/getAllMasterwithoutToken",
  async ({ companyId } = {}) => {
    try {
      const { data } = await axios.get(
        `master/GetCompanyMasterData?CompanyId=${companyId}`
      );
      // console.log("masterDataSlice", data);

      return data;
    } catch (error) {
      // console.error("Error in getAllMaster:", error.message);
      throw error; // rethrow to handle in rejected case
    }
  }
);

export const loadEmailConfig = createAsyncThunk(
  "masters/loadEmailConfig",
  async (CompanyId) => {
    try {
      // const { data } = await axios.get(`master/GetCompanyMasterData`);
      const { data } = await axios.get(
        `master/EmailConfigurationGetbyCompanyId?CompanyId=${CompanyId}`
      );

      // console.log("masterDataSlice", data);

      return data;
    } catch (error) {
      // console.log(error.message);
    }
  }
);
export const getCitiesByStateId = createAsyncThunk(
  "masters/getCitiesByStateId",
  async (stateId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `master/CityMasterGetByStateId?StateId=${stateId}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateMaster = createAsyncThunk(
  "masters/updateMaster",
  async ({ id, values }) => {
    try {
      const { data } = await axios({
        method: "put",

        url: `masters/${id}`,
        data: {
          ...values,
        },
      });
      toast.success("Master Reason updated successfully!");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in updating Master Reason try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

const masterSlice = createSlice({
  name: "masters",
  initialState,
  reducers: {
    clearMaster: (state) => {
      state.masters = null;
    },
  },
  extraReducers: (builder) => {
    // 1) ====== builders for getAllMaster ======

    builder.addCase(getAllMaster.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getAllMaster.fulfilled, (state, action) => {
      state.loading = false;
      state.masters = action.payload || null;
    });

    builder.addCase(getAllMaster.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

     // 1) ====== builders for getAllMaster ======

    builder.addCase(getAllMasterwithoutToken.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getAllMasterwithoutToken.fulfilled, (state, action) => {
      state.loading = false;
      state.mastersWt = action.payload || [];
    });

    builder.addCase(getAllMasterwithoutToken.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    builder.addCase(loadEmailConfig.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(loadEmailConfig.fulfilled, (state, action) => {
      state.loading = false;
      state.emailConfig = action.payload;
    });

    builder.addCase(loadEmailConfig.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 1) ====== builders for getCitiesByStateId ======

    builder.addCase(getCitiesByStateId.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getCitiesByStateId.fulfilled, (state, action) => {
      state.loading = false;
      state.cities = action.payload || [];
    });

    builder.addCase(getCitiesByStateId.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2) ====== builders for addMaster  ======

    builder.addCase(addMaster.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addMaster.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(addMaster.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 2) ====== builders for addEmailConfiguration  ======

    builder.addCase(addEmailConfiguration.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addEmailConfiguration.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(addEmailConfiguration.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 3) ====== builders for updateMaster ======

    builder.addCase(updateMaster.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateMaster.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(updateMaster.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    // 4) ====== builders for deleteMaster  ======

    builder.addCase(deleteMaster.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(deleteMaster.fulfilled, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteMaster.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

export default masterSlice.reducer;
export const { clearMaster } = masterSlice.actions;
